export const HeaderIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="header-icon"
  >
    <path d="M12.0039 22.0029C6.48107 22.0029 2.00391 17.5258 2.00391 12.0029C2.00391 6.48008 6.48107 2.00293 12.0039 2.00293C17.5267 2.00293 22.0039 6.48008 22.0039 12.0029C22.0039 17.5258 17.5267 22.0029 12.0039 22.0029ZM12.0039 20.0029C16.4222 20.0029 20.0039 16.4212 20.0039 12.0029C20.0039 7.58465 16.4222 4.00293 12.0039 4.00293C7.58563 4.00293 4.00391 7.58465 4.00391 12.0029C4.00391 16.4212 7.58563 20.0029 12.0039 20.0029ZM8.50391 14.0029H14.0039C14.28 14.0029 14.5039 13.7791 14.5039 13.5029C14.5039 13.2268 14.28 13.0029 14.0039 13.0029H10.0039C8.6232 13.0029 7.50391 11.8836 7.50391 10.5029C7.50391 9.12222 8.6232 8.00293 10.0039 8.00293H11.0039V6.00293H13.0039V8.00293H15.5039V10.0029H10.0039C9.72777 10.0029 9.50391 10.2268 9.50391 10.5029C9.50391 10.7791 9.72777 11.0029 10.0039 11.0029H14.0039C15.3846 11.0029 16.5039 12.1222 16.5039 13.5029C16.5039 14.8836 15.3846 16.0029 14.0039 16.0029H13.0039V18.0029H11.0039V16.0029H8.50391V14.0029Z" />
  </svg>
);

export const MoonIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="header-icon"
  >
    <path d="M10 7C10 10.866 13.134 14 17 14C18.9584 14 20.729 13.1957 21.9995 11.8995C22 11.933 22 11.9665 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C12.0335 2 12.067 2 12.1005 2.00049C10.8043 3.27098 10 5.04157 10 7ZM4 12C4 16.4183 7.58172 20 12 20C15.0583 20 17.7158 18.2839 19.062 15.7621C18.3945 15.9187 17.7035 16 17 16C12.0294 16 8 11.9706 8 7C8 6.29648 8.08133 5.60547 8.2379 4.938C5.71611 6.28423 4 8.9417 4 12Z" />
  </svg>
);

export const NotificationIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="header-icon"
  >
    <path d="M20 17H22V19H2V17H4V10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10V17ZM18 17V10C18 6.68629 15.3137 4 12 4C8.68629 4 6 6.68629 6 10V17H18ZM9 21H15V23H9V21Z" />
  </svg>
);

export const LightModeSvg = () => (
  <svg
    style={{ cursor: "pointer" }}
    width="56"
    height="32"
    viewBox="0 0 56 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="56" height="32" rx="16" fill="#F0F3F7" />
    <rect x="4" y="4" width="24" height="24" rx="12" fill="white" />
    <path
      d="M14.6668 12.6666C14.6668 15.2439 16.7561 17.3332 19.3335 17.3332C20.1926 17.3332 20.9976 17.1301 21.689 16.7449C22.0813 16.5263 22.6324 16.785 22.549 17.2263C21.9638 20.3223 19.2631 22.6665 16.0001 22.6665C12.3183 22.6665 9.3335 19.6817 9.3335 15.9999C9.3335 12.7341 11.6818 10.0167 14.782 9.44434C15.2225 9.36302 15.4783 9.91233 15.2595 10.3032C14.8715 10.9964 14.6668 11.8042 14.6668 12.6666ZM10.6668 15.9999C10.6668 18.9454 13.0546 21.3332 16.0001 21.3332C18.039 21.3332 19.8107 20.1891 20.7081 18.5079C20.2631 18.6123 19.8025 18.6665 19.3335 18.6665C16.0197 18.6665 13.3335 15.9803 13.3335 12.6666C13.3335 12.1976 13.3877 11.7369 13.4921 11.292C11.8109 12.1894 10.6668 13.9611 10.6668 15.9999Z"
      fill="#303940"
    />
  </svg>
);

export const DarkModeSvg = () => (
  <svg
    style={{ cursor: "pointer" }}
    width="56"
    height="32"
    viewBox="0 0 56 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="56" height="32" rx="16" fill="#2F343A" />
    <rect x="28" y="4" width="24" height="24" rx="12" fill="#263d37" />
    <g  clipPath="url(#clip0_241_6937)">
      <path
        d="M40 19.5C38.067 19.5 36.5 17.933 36.5 16C36.5 14.067 38.067 12.5 40 12.5C41.933 12.5 43.5 14.067 43.5 16C43.5 17.933 41.933 19.5 40 19.5ZM40 19.1667C41.7489 19.1667 43.1667 17.7489 43.1667 16C43.1667 14.2511 41.7489 12.8333 40 12.8333C38.2511 12.8333 36.8333 14.2511 36.8333 16C36.8333 17.7489 38.2511 19.1667 40 19.1667ZM39.8333 9.33333C39.8333 9.24128 39.908 9.16666 40 9.16666C40.0921 9.16666 40.1667 9.24128 40.1667 9.33333V10C40.1667 10.092 40.0921 10.1667 40 10.1667C39.908 10.1667 39.8333 10.092 39.8333 10V9.33333ZM39.8333 22C39.8333 21.908 39.908 21.8333 40 21.8333C40.0921 21.8333 40.1667 21.9079 40.1667 22V22.6667C40.1667 22.7587 40.0921 22.8333 40 22.8333C39.908 22.8333 39.8333 22.7587 39.8333 22.6667V22ZM35.1681 11.4038C35.103 11.3387 35.103 11.2332 35.1681 11.1681C35.2332 11.103 35.3387 11.103 35.4038 11.1681L35.8752 11.6395C35.9403 11.7046 35.9403 11.8101 35.8752 11.8752C35.8101 11.9403 35.7046 11.9403 35.6395 11.8752L35.1681 11.4038ZM44.1248 20.3605C44.0597 20.2954 44.0597 20.1899 44.1248 20.1248C44.1899 20.0597 44.2954 20.0597 44.3605 20.1248L44.8319 20.5962C44.897 20.6613 44.897 20.7668 44.8319 20.8319C44.7668 20.897 44.6613 20.897 44.5962 20.8319L44.1248 20.3605ZM44.5962 11.1681C44.6613 11.103 44.7668 11.103 44.8319 11.1681C44.897 11.2332 44.897 11.3387 44.8319 11.4038L44.3605 11.8752C44.2954 11.9403 44.1899 11.9403 44.1248 11.8752C44.0597 11.8101 44.0597 11.7046 44.1248 11.6395L44.5962 11.1681ZM35.6395 20.1248C35.7046 20.0597 35.8101 20.0597 35.8752 20.1248C35.9403 20.1899 35.9403 20.2954 35.8752 20.3605L35.4038 20.8319C35.3387 20.897 35.2332 20.897 35.1681 20.8319C35.103 20.7668 35.103 20.6613 35.1681 20.5962L35.6395 20.1248ZM46.6667 15.8333C46.7587 15.8333 46.8333 15.9079 46.8333 16C46.8333 16.092 46.7587 16.1667 46.6667 16.1667H46C45.908 16.1667 45.8333 16.092 45.8333 16C45.8333 15.9079 45.908 15.8333 46 15.8333H46.6667ZM34 15.8333C34.0921 15.8333 34.1667 15.9079 34.1667 16C34.1667 16.092 34.0921 16.1667 34 16.1667H33.3333C33.2413 16.1667 33.1667 16.092 33.1667 16C33.1667 15.9079 33.2413 15.8333 33.3333 15.8333H34Z"
        fill="#45cb85"
        stroke="#45cb85"
      />
    </g>
    <defs>
      <clipPath id="clip0_241_6937">
        <rect width="16" height="16" fill="#45cb85" transform="translate(32 8)" />
      </clipPath>
    </defs>
  </svg>
);
